import { createStore } from 'zustand/vanilla';
import setDataReducer from "@/utils/zustand/helpers";
export const defaultInitState = {
    one: {
        open: false,
        title: null,
        description: null,
        component: null,
        className: null,
        noBackDropClose: false
    }
};
export const createModalsStore = function() {
    let initState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultInitState;
    return createStore()((set)=>({
            ...initState,
            setData: (payload)=>set((state)=>setDataReducer(state, payload)),
            toggleModal: (param)=>{
                let { id, open, component, className, description, title } = param;
                set((state)=>{
                    // constants
                    const newOpen = typeof open === "boolean" ? open : !state[id].open;
                    if (newOpen) return {
                        [id]: {
                            open: newOpen,
                            component,
                            className,
                            description,
                            title
                        }
                    };
                    else {
                        setTimeout(()=>set({
                                [id]: defaultInitState.one
                            }), 500);
                        return {
                            [id]: {
                                ...state[id],
                                open: newOpen
                            }
                        };
                    }
                });
            }
        }));
};
